/**
 * 游戏公告
*/
import { createAPI } from '../setup'
//  import hostConfig from '../config'
const NOTICE = {
    // 获取用户可展示公告链接
    onlineGameNoticeUrl: (data) => createAPI('/game/onlineGameNoticeUrl', 'post', data),
    // 获取游戏公告展示内容
    gameNoticeShow: (data) => createAPI('/user/gameNoticeShow', 'post', data),
    // 上报跳转链接点击次数
    noticeLinkClick: (data) => createAPI('/user/noticeLinkClick', 'post', data)
}
export default NOTICE
